import {
  BaseMFEMountParams,
  BaseMFEMountResponse,
  BaseMFEProps,
  BaseMicroFrontend,
} from './BaseMicroFrontend';

export type MicrofrontendMountParams = BaseMFEMountParams;

export type SpecificMicroFrontendProps = Omit<MicroFrontendProps, 'exposedPath' | 'name'>;

export interface MicroFrontendProps<T = any> extends BaseMFEProps {
  basePath?: string;
  history?: History;
  permissions?: any;
  openLogin?: any;
  tryGuestLogin?: any;
  loggedUser?: any;
  isMobile?: boolean;
  isTablet?: boolean;
  isSmartTV?: boolean;
  isAppMobile?: boolean;
  lang?: string;
  tracker?: any;
  company?: any;
  params?: T;
  platformType?: string;
  platforms?: string;
}

interface MountResponse extends BaseMFEMountResponse {
  onParentNavigate: ({ pathname }: { pathname: string }) => void;
  onParamsChange: (props: any) => void;
}

export class MicroFrontend extends BaseMicroFrontend<MicroFrontendProps> {
  buildMountParams(): MicrofrontendMountParams {
    const { params, ...fields } = this.props;
    return { ...fields, ...params };
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  afterMount({}: MountResponse): void {}
}
